export const counters = [
  { value: 11 , suffix: "", text: "Districts", class: "style-1-1" },
  { value: 40 , suffix: "+", text: "Industries", class: "style-1-2" },
  { value: 15, suffix: "+", text: "Associations", class: "style-1-3" },
  // { value: 2, suffix: "L+", text: "Daily Market Footfall", class: "style-1-4" },
];

export const counters2 = [
  {
    id: 1,
    icon: "icon-house",
    number: 900,
    subText: "+",
    label: "Homes for Sale",
    hasSubNumber: false,
  },
  {
    id: 2,
    icon: "icon-user-2",
    number: 287,
    subText: "",
    label: "Real Estate Agents",
    hasSubNumber: false,
  },
  {
    id: 3,
    icon: "icon-shield",
    number: 3,
    subText: "+",
    label: "Properties Sold",
    hasSubNumber: true,
    subNumber: ".600",
  },
];

export const counterData = [
  {
    value: 950,

    label: "Dream house",
    className: "style-4-1",
  },
  {
    value: 2,
    subText: ".200",

    label: "Happy clients",
    className: "style-4-2",
  },
  {
    value: 470,

    label: "Local Agent",
    className: "style-4-3",
  },
  {
    value: 2,

    subText: ".500",
    label: "Property Available",
    className: "style-4-4",
  },
];

export const counterData2 = [
  {
    id: 1,
    value: 950,
    subText: "Dream house",
    className: "style-4-1",
  },
  {
    id: 2,
    value: 3,
    additionalText: ".200",
    subText: "Happy clients",
    className: "style-4-2",
  },
  {
    id: 3,
    value: 470,
    subText: "Local Agent",
    className: "style-4-3",
  },
  {
    id: 4,
    value: 2,
    additionalText: ".500",
    subText: "Property Available",
    className: "style-4-4",
  },
];
